<template>
  <div>
    <input type="file" id="file" ref="file" @change="handleFileUpload()" hidden>
    <button class="btn w-280px" @click="chooseFiles">上傳檔案</button>
    {{ file }}
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    dir: {
      type: String,
      default: '',
    },
    format: {
      type: [Array, String],
      default: () => [
        'video/mp4',
        'video/quicktime',
        'video/x-msvideo',
      ],
    },
  },
  data: () => ({
    isMatch: true,
  }),
  computed: {
    file() {
      if (this.value && this.value.indexOf('/storage/') === 0) {
        return `${process.env.VUE_APP_HOST}${this.value}`;
      }

      return this.value;
    },
  },
  methods: {
    ...mapActions({
      upload: 'upload',
    }),
    handleFileUpload() {
      const formData = new FormData();
      const file = this.$refs.file.files[0];
      // if (this.format.indexOf(file.type) === -1) {
      //   return;
      // }
      formData.append('file', file);
      formData.append('dir', this.dir);
      this.upload(formData).then((res) => {
        this.$emit('input', res.url);
      }).catch((err) => {
        // 原本這裡沒有 catch，上傳失敗（例如檔案過大）時畫面會完全沒反應、
        // 也不會有任何提示，很容易被誤以為是後端沒有存到資料。
        /* eslint-disable no-alert */
        alert(err.message || '影片/檔案上傳失敗，請確認檔案大小未超過限制後再試一次。');
        /* eslint-enable no-alert */
      });
    },
    chooseFiles() {
      this.$refs.file.click();
    },
  },
};
</script>

<style lang="scss"></style>
